import React from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { App } from './App'
import { installGtagStubs } from './api/deferredAnalytics'
import './features/legal/legal-document.css'
import { initI18n } from './i18n'
import './index.css'
import { parseLocalePath } from './navigation/locale'
import { initSentry } from './sentry'

async function bootstrap() {
    const { locale } = parseLocalePath(window.location.pathname)
    await initI18n(locale)

    initSentry()
    installGtagStubs()

    const rootElement = document.getElementById('root')
    if (!rootElement) {
        throw new Error('Root element #root not found')
    }

    const app = (
        <React.StrictMode>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </React.StrictMode>
    )

    if (rootElement.childElementCount > 0) {
        hydrateRoot(rootElement, app)
    } else {
        createRoot(rootElement).render(app)
    }
}

bootstrap()
